import { CompositeLayer } from '@deck.gl/core'
import { TileLayer } from '@deck.gl/geo-layers'
import { BitmapLayer } from '@deck.gl/layers'
import { load } from '@loaders.gl/core'

class WMSLayer extends CompositeLayer<any, any> {
  shouldUpdateState({ changeFlags }): boolean {
    if (!changeFlags.propsChanged) {
      return false
    }
    if (changeFlags.propsOrDataChanged) {
      return true
    }
    if (changeFlags.updateTriggersChanged) {
      return true
    }

    return false
  }

  renderLayers() {
    return [
      new TileLayer({
        ...this.props,
        tileSize: 256,
        minZoom: 0,
        id: this.props.id + '-tile',
        getTileData: async (tile) => {
          const { bbox } = tile
          const { east, north, south, west } = bbox
          const urlQueryStringParams = {
            bbox: [west, south, east, north].join(','),
            format: 'image/png',
            width: '256',
            height: '256',
            request: 'GetMap',
            service: 'WMS',
            srs: 'EPSG:4326',
            crs: 'CRS:84',
            transparent: 'true',
            styles: '',
            ...this.props.tileLayerProps.urlQueryStringParams
          }
          const urlQueryString = new URLSearchParams(urlQueryStringParams)
          return await load(this.props.tileLayerProps.url + urlQueryString, {
            worker: false
          })
        },
        renderSubLayers: (props) => {
          const {
            bbox: { west, south, east, north }
          } = props.tile
          return [
            new BitmapLayer(props, {
              data: null,
              image: props.data,
              bounds: [west, south, east, north]
            })
          ]
        }
      })
    ]
  }
}
WMSLayer.layerName = 'WMSLayer'
export default WMSLayer
